namespace RioERP.Wallet {
    export interface CreditJournalForm {
        Name: Serenity.StringEditor;
        Description: Serenity.StringEditor;
        Kind: Serenity.IntegerEditor;
    }

    export class CreditJournalForm extends Serenity.PrefixedContext {
        static formKey = 'Wallet.CreditJournal';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!CreditJournalForm.init)  {
                CreditJournalForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.IntegerEditor;

                Q.initFormType(CreditJournalForm, [
                    'Name', w0,
                    'Description', w0,
                    'Kind', w1
                ]);
            }
        }
    }
}
